import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { plainToClass } from 'class-transformer';
import { Formation } from '../../../shared/data/formation';
import { EditCritereComponent } from '../../criteres/edit-critere/edit-critere.component';
import { LicenceKey } from '../../../shared/data/licencekey';

@Component({
  selector: 'ngx-edit-database',
  templateUrl: './edit-database.component.html',
  styleUrls: ['./edit-database.component.scss']
})
export class EditDatabaseComponent implements OnInit {
  @Input() id: number;
  /* nome;
  desc;
  cate:any = []; */
  key = new LicenceKey();
  hideLoader =true;
  hideButon =false;
  // pr;

  

  constructor(protected dialogRef: NbDialogRef<EditDatabaseComponent>,private apiService:ApiService, private dialogService: NbDialogService, private router:Router,private sendeurService:EventSendeurService, public toastr: NbToastrService) {
  

  }

  ngOnInit() {

    if(this.id !== 0)
    this.getOneLicence();
   
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  

  updateLicence(){

    //console.log(this.key)

    if( this.id !== 0 ) {

      this.hideButon= true;
      this.hideLoader = false;
      this.apiService.updateLicenceProvider(this.key).subscribe((data:LicenceKey) =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success");
        this.dialogRef.close();
        // this.sendeurService.sendFormationEvent(data); 

      },(err) =>{
        console.log(err);
        this.toastr.danger("echec de mise à jour");
        this.hideButon= false;
        this.hideLoader = true;
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }
    
      })

    } else {


      this.hideLoader = false;
      this.hideButon = true;
      

      this.apiService.addLicenceProvider(this.key).subscribe((data:LicenceKey) =>{
        console.log(data);
        this.toastr.success("Licence crée avec success");
        this.dialogRef.close();
        // this.sendeurService.sendFormationEvent(data); 
      },(err) =>{
        this.hideLoader = true;
        this.hideButon = false;
        this.toastr.danger("echec de l'operation","erreur");
        console.log(err);
      
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page","echec");
        }
    
    })



    }
    
  }

  getOneLicence(){

    this.apiService.getOneLicenceProvider(this.id).subscribe(data =>{
     this.key = plainToClass(LicenceKey, data as object);

    },(err) =>{

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })
  }

  

 

  
  

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }

  /* typeCatChanged($event){

    this.cat.type_content = $event;

  } */

  


  /* addAdmissibility() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'admissibility'}});
  } */


}
